
/**
 * Add a class to an element.
 * @param {Element} node
 * @param {string} className
 */
export const hasClass = function (node, className) {
  var classesString = node.className
  // TODO Doesn't really work if the class is a subset of the real class
  return classesString.includes(className)
}

/**
 * Add a class to an element.
 * @param {Element} node
 * @param {string} className
 */
export const addClass = function (node, className) {
  var classesString = node.className
  if (classesString.includes(className)) return
  node.className = classesString + " " + className
}

/**
 * Remove a class from an element.
 * @param {Element} node
 * @param {string} className
 */
export const removeClass = function (node, className) {
  var classesString = node.className
  var classes = classesString.split(" ").filter((str) => str)
  classes = classes.filter((str) => str != className)
  node.className = classes.join(" ")
}
